import {
  generateUID,
} from './../_util.js';
import Cookie from 'js-cookie';

/** Class representing a site. */
class Site {
  /**
    Assigns siteInitalState
    @param {func} config.dev - will log anywhwere you set log point
    @param {func} config.onRouteChange - callback when routes change. This returns (oldRouteState, newRouteState, cb). Use the callback to let the Site class know that you are done and it can handle the click events.
    @param {string} config.baseUrl - base url where the Site class will be initiated on and will high jack links that are clicked within.
  */
  constructor(config) {
    this.state = {
      _prefix: generateUID(),
      mount: undefined,
      dev: false,
      baseUrl: '/',
      categories: [],
      cases: {},
      useAdultNag: false,
      routeState: {
        path: window.location.pathname,
        currentComponentId: undefined,
      },
    };

    const that = this;
    that.update(config);
    that.addLinkEventListeners();

    if (typeof this.state.onLoad === 'function') {
      this.state.onLoad(this.state, this);
    }

    // listens for forward and back button in browser
    window.addEventListener('popstate', function(e) {
      // console.log(e);
      that.routeChange();
    });

    this.routeChange();
  }

  /** 
  Updates the state
  @return updates `this.state`
  */
  update(newState) {
    this.state = Object.assign({}, this.state, newState);
  }

  /**
  * method routeChange
  * This should be fired when a route change happens; default is: 
  * 1. When gallery initializes in the `contructor` method. 
  * 2. When the popstate event is fired (gallery is listening for this). e.g. when you click back or forward using the history of the browser.
  * 3. addLinkEventListener adds link event listeners to anchor links that have the baseUrl within the href. 
  */
  routeChange(linkClickedObject) {

    let nextPath = (linkClickedObject && linkClickedObject.href) ? linkClickedObject.href : window.location.pathname;
    
    let newRouteState = linkClickedObject || {};
    let oldRouteState = this.state.routeState;

    newRouteState.type = "newRouteState";
    newRouteState.path = nextPath;

    oldRouteState.type = "oldRouteState";

    if (linkClickedObject) {
      let historyObj = {
        lastPath: this.state.routeState.path
      };

      history.pushState(historyObj, 'state', nextPath);
    }

    if (typeof this.state.onRouteChange === 'function') {

      const that = this;

      let $loading = $(`#${this.state.mount}`).find('div.loading');

      $loading.css({ opacity: 1 });

      this.state.onRouteChange(oldRouteState, newRouteState, () => {
        this.update({
          routeState: newRouteState,
        });

        that.addLinkEventListeners();
        $loading.css({ opacity: 0 });
      }, this);
    }
  }


  /**
  * addLinkEventListeners - loops through all anchor links, and if the anchor link contains the baseUrl (defined in the state) it will remove any event listeners on the anchor then apply a function defined within this method called `linkClicked`.

  * linkCLicked {function} - checks if there is an ID attached to the link that was clicked. It removed the window.location.origin value from the href if it exists then fires the `Site.routeChange` method and passes an object containing an id if it exists and the remaining portion of the href which is just the path of the URL.
  */
  addLinkEventListeners() {

    const that = this;

    function linkClicked(e) {
      let href = this.attributes.href.value;
      let id = (this.attributes['data-id']) ? this.attributes['data-id'].value : undefined;

      if (href.indexOf(that.state.baseUrl) !== -1) {
        // console.log('base url is contained within the link');
        // Handle on click event
        e.preventDefault();
      }

      let currentLocation = window.location;

      // this checks to see if the host name is part of the link
      if (href.indexOf(currentLocation.origin) !== -1) {

        // if it is, then remove it and pass it along
        href = href.replace(currentLocation.origin, '');
      }

      let linkClickedObject = {
        id: id,
        href: href,
      };
      
      if (linkClickedObject.href && that.state.routeState.path.replace(new RegExp('/', 'g'), '') !== linkClickedObject.href.replace(new RegExp('/', 'g'), '')) {
        
        if (that.state.useAdultNag && this.attributes.class && this.attributes.class.value.indexOf('adult') !== -1) {
          var confirmAdultNotice = () => confirm('This category contains nudity. Please click OK to confirm you are at least 18 years of age and are not offended by such material.');

          if (Cookie.get('adult_nag_warning') !== undefined) {
            that.routeChange(linkClickedObject);
          } else if (confirmAdultNotice()) {
            that.routeChange(linkClickedObject);
            Cookie.set('adult_nag_warning', 'has-agreed');
          }
        } else {
          that.routeChange(linkClickedObject);
        }
      }

      if ($(this).hasClass('category__list__item__link')) {
        $(window).trigger('category-selected');
      }
      $('.topbar__account__info__logout').removeClass('hover dropdown');
    }

    $(`a`).each((i, a) => {
      // Only adding and removing the event listeners from the anchor links that need it. Rules:
      // - they must have an href
      // - the href must contain the baseUrl
      if (a.attributes.href && a.attributes.href.value.indexOf(this.state.baseUrl) !== -1) {
        $(a).off().on('click', linkClicked); // removed all event listeners then add em back
      }
    });

    this.addFavoriteLinkListeners();
  }

  /**
    Adds link event listeners to all classes with "gallery-favorites". 
  */
  addFavoriteLinkListeners() {
    var that = this;

    if (!this.state.isBasic) {
      $(`.gallery-favorites`).each((index, favItem) => {
        $(favItem).off().on('click', handleFavoriteAction);
      });
    } else {
      return;
    }


    function handleFavoriteAction(e) {
      if (e) {
        e.preventDefault();
      }

      $(this).toggleClass('active').find('.heart-icon').toggleClass('active');
        
      var user = Cookie.getJSON('gallery-user');
      if (user) {
        that.state.api.toggleFavorite($(this).attr('data-id'));

        if (!user.email) {
          $(window).trigger('show-create-account');
        }
      } else {
        that.state.api.createTempUserAndAddFavorite($(this).attr('data-id'));

        if ($(this).hasClass('dismiss-create-account')) {
          $(window).trigger('hide-create-account');
        } else {
          $(window).trigger('show-create-account');
        }
      }
    }
  }
}


export default Site;


// WEBPACK FOOTER //
// ./src/scripts/site/index.js